module.exports = "<h3>We couldn't find your invitation key! Please follow the link in the invitation e-mail that you received.</h3>"